export const authApi = {
  register: (): string => `api/auth/registration`,
  login: (): string => `api/auth/login`,
  logout: (): string => `api/auth/logout`,
};
